import React from 'react'
import injectSheet from 'react-jss'
import styles from './container.styles.js'

const Container = ({ classes, children }) => {
  return <div className={classes.container}>{children}</div>
}

export default injectSheet(styles)(Container)
